<template>
  <div class="answer_box">
    <div class="answer_content">
      <img
        :src="
          answerData.createHeadUrl ||
          require('../../../assets/images/argicSubjectInfo/header_photo.png')
        "
        v-if="answerData.createByType == '1'"
        alt=""
      />
      <img
        :src="
          answerData.createHeadUrl ||
          require('../../../assets/images/argicSubjectInfo/expert.png')
        "
        v-else
        alt=""
      />
      <div class="answer_content_div">
        <div class="answer_content_user">
          <div>
            <span>{{ answerData.createName }}</span>
            <i>{{ answerData.createTime }}</i>
            <em>{{ answerData.createTitle }}</em>
          </div>
          <el-button
            type="text"
            icon="el-icon-delete"
            v-if="answerData.createByType == '1' && deleteState"
            @click="removeAnswer(answerData.id)"
          >
            删除
          </el-button>
        </div>
        <div class="answer_content_text">{{ answerData.answerRemark }}</div>
        <div class="answer_content_img" v-if="answerData.answerImage">
          <el-image
            style="width: 100px; height: 100px"
            v-for="(item, index) in answerData.answerImage.split(',')"
            :key="index"
            :src="item"
            :preview-src-list="answerData.answerImage.split(',')"
          >
          </el-image>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { expertConsultation } from "@/api/request/snkd.produce";
export default {
  props: {
    answerData: {
      type: Object,
      require: true,
    },
    deleteState: {
      type: Boolean,
      require: true,
    },
  },
  inject: ["getList"],
  data() {
    return {};
  },
  methods: {
    removeAnswer(id) {
      this.$confirm("是否确定删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            await expertConsultation.probeDelete(id);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          } catch (error) {
            console.log(error);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style scoped lang="scss">
.answer_content {
  display: flex;
  align-items: flex-start;
  img {
    width: 50px;
  }
  .answer_content_div {
    flex: 1;
    padding: 12px 0 10px 20px;
  }
  .answer_content_user {
    color: #999;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    div {
      span {
        color: #333;
        font-size: 20px;
      }
      i {
        margin: 0 30px 0 20px;
      }
    }
    .el-button--text {
      color: #999;
    }
  }
  .answer_content_text {
    color: #666;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    padding: 10px 0;
  }
  .answer_content_img {
    margin-top: 10px;
    .el-image {
      margin-right: 20px;
      border-radius: 4px;
    }
    :last-child {
      margin-right: 0px;
    }
  }
}

.answer_box {
  border-top: 1px dashed #f4f4f4;
  padding-top: 14px;
}
</style>
